import React, { useState } from 'react';
import HelpDrawer from './HelpDrawer';
import '../styles/HelpDrawer.css';

const HelpButton = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <button 
        className="floating-help-btn"
        onClick={() => setIsDrawerOpen(true)}
        aria-label="راهنمای سامانه"
        data-testid="help-button"
      >
        <i className="fas fa-question-circle"></i>
        <span className="help-btn-text">راهنما</span>
      </button>

      <HelpDrawer 
        isOpen={isDrawerOpen} 
        onClose={() => setIsDrawerOpen(false)} 
      />
    </>
  );
};

export default HelpButton;